import {Action} from '@ngrx/store';

export const SET_OBJECT = '[OBJECT] set content';
export const DISMIS_OBJECT = '[OBJECT] dismis content';

export class SetObject implements Action {
  readonly type = SET_OBJECT;
  constructor(public payload: Object) {}
}

export class DismisObject implements Action {
  readonly type = DISMIS_OBJECT;
  constructor(public payload: Object) {}
}

export type Actions = SetObject | DismisObject;
